<template>
    <b-button
        variant="primary"
        v-if="$temAcessoView('CTRLACS-USR-04')"
        @click.stop="confirmarResetarSenha()"
        class="mr-2"
    >
        <i class="fa fa-key"></i> Resetar Senha
    </b-button>
</template>

<script>
import UsuariosServicos from './UsuariosServicos'

export default {
    props: {
        usuario: {
            type: Object,
            required: true
        }
    },

    methods: {
        confirmarResetarSenha() {
            this.$swal({
                title: 'Reset de Senha',
                html: `Confirma o reset da senha do usuário <b>${this.usuario.nome}</b>?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then(result => {
                if (result.value) {
                    this.resetarSenha()
                }
            })
        },

        resetarSenha() {
            this.$store.dispatch('addRequest')
            UsuariosServicos.resetarSenhaUsuario(
                this.$route.params.usuarioId
            ).then(response => {
                if (response) {
                    if (response.success) {
                        this.$toast.success(
                            'Reset de senha realizado com sucesso!',
                            'OK',
                            this.$toastConfig.success
                        )
                    } else {
                        this.$toast.error(
                            response.errors,
                            'ERROR',
                            this.$toastConfig.error
                        )
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        }
    }
}
</script>
